<div id="app--container">
  <div id="app-header--container">
    <img id="app-header--logo" src="images/peak_logo.svg">
    <div class="blue-background">
      <span><i>Know</i> the people who do insurance.</span>
    </div>
  </div>

  <div>
    <router-outlet />
  </div>

  <div id="app-footer--container">
    <span></span>
  </div>  
</div>
